<nav
  class="navbar navbar-expand-lg navbar-dark fixed-top"
  [class.bg-color-default.border-bottom-0]="!isLandingPage()"
  [class.mobile-menu-open]="isAuthenticated() && !isMenuCollapsed"
>
  <div class="container mw-100 justify-content-between">
    <!-- Logo/Brand -->
    <a [routerLink]="isAuthenticated() ? '/projects' : '/'" class="navbar-brand p-0">
      @if (isAuthenticated()) {
        <span class="client-brand">
          @if (companyLogoUrl() && !companyLogoLoadFailed()) {
            <img
              class="client-brand-logo"
              [src]="companyLogoUrl()"
              [alt]="'Logotipo de ' + companyDisplayName()"
              (error)="onCompanyLogoError()"
            />
          }

          <h6 class="logo-header client-brand-name" [title]="companyDisplayName()">
            {{ companyDisplayName() }}
          </h6>
        </span>
      } @else {
        <h6 class="logo-header">TRACKGAINS®</h6>
      }
    </a>

    @if (isAuthenticated()) {
      <!-- Mobile menu toggle -->
      <button
        class="navbar-toggler border-0 p-1"
        type="button"
        (click)="isMenuCollapsed = !isMenuCollapsed"
        [attr.aria-expanded]="!isMenuCollapsed"
        aria-controls="navbarNav"
      >
        @if (currentUser()?.avatar) {
          <img
            [src]="currentUser()!.avatar"
            [alt]="currentUser()!.nome"
            class="rounded-circle"
            width="32"
            height="32"
          />
        } @else {
          <div
            class="bg-color-surface-light rounded-circle d-flex align-items-center justify-content-center"
            style="width: 32px; height: 32px"
          >
            <span class="text-primary-custom fw-bold">
              {{ (currentUser()?.nome?.charAt(0) || 'U').toUpperCase() }}
            </span>
          </div>
        }
      </button>

      <div class="navbar-collapse" id="navbarNav" [ngbCollapse]="isMenuCollapsed">
        <!-- Navigation items -->
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <!-- TG-382 #21 / TG-492: rótulo movido do dropdown para cá ao remover a duplicidade -->
            <a routerLink="/projects" routerLinkActive="active" class="nav-link">
              <i class="bi bi-folder me-1"></i>
              {{ (isTomadorCredito() ? 'header.myProjects' : 'header.projects') | transloco }}
            </a>
          </li>

          @if (isAdminLike()) {
            <li class="nav-item">
              <a routerLink="/admin/users" routerLinkActive="active" class="nav-link">
                <i class="bi bi-people me-1"></i>
                {{ 'header.manageUsers' | transloco }}
              </a>
            </li>
          }

          @if (isSuper()) {
            <li class="nav-item">
              <a routerLink="/admin/customers" routerLinkActive="active" class="nav-link">
                <i class="bi bi-building me-1"></i>
                {{ 'header.manageClients' | transloco }}
              </a>
            </li>
          }

          @if (canViewDashboards()) {
            <li class="nav-item">
              <a routerLink="/platform-data" routerLinkActive="active" class="nav-link">
                <i class="bi bi-grid-1x2 me-1"></i>
                {{ 'header.platformData' | transloco }}
              </a>
            </li>
          }
        </ul>
      </div>

      <!-- User actions -->

      <!-- Mobile user menu (flat, no dropdown) -->
      <div class="d-lg-none w-100 navbar-nav" [ngbCollapse]="isMenuCollapsed">
        <hr class="border-secondary opacity-50 my-2" />

        <a class="nav-link" href="#" (click)="$event.preventDefault(); openHelpGuides()">
          <i class="bi bi-question me-2"></i>
          {{ 'header.helpGuides' | transloco }}
        </a>

        <a class="nav-link" href="#" (click)="$event.preventDefault(); openProfileModal()">
          <i class="bi bi-person me-2"></i>
          {{ 'header.profile' | transloco }}
        </a>

        <a class="nav-link" href="#" (click)="$event.preventDefault(); openChangePasswordModal()">
          <i class="bi bi-lock me-2"></i>
          {{ 'header.changePassword' | transloco }}
        </a>

        @if (isAdminLike()) {
          <a class="nav-link" href="#" (click)="$event.preventDefault(); openEditEmpresa()">
            <i class="bi bi-building me-2"></i>
            {{ 'header.myCompany' | transloco }}
          </a>
        }
        @if (isReferralEligible()) {
          <a class="nav-link" routerLink="/referral">
            <i class="bi bi-people me-2"></i>{{ 'header.referral' | transloco }}
          </a>
        }

        @if (isSuper()) {
          <a class="nav-link" routerLink="/admin/fees">
            <i class="bi bi-percent me-2"></i>
            {{ 'header.manageFees' | transloco }}
          </a>
        }

        @if (isAdminOrSuper()) {
          <a class="nav-link" routerLink="/admin/metrics">
            <i class="bi bi-bar-chart me-2"></i>
            {{ 'header.metricsDashboard' | transloco }}
          </a>
        }

        <hr class="border-secondary opacity-50 my-2" />

        <span class="nav-link pe-none opacity-75">
          <i class="bi bi-globe2 me-2"></i>
          {{ 'header.language' | transloco }}
        </span>

        @for (lang of languageOptions; track lang.value) {
          <a
            class="nav-link ps-4"
            [class.active]="transloco.activeLang() === lang.value"
            href="#"
            (click)="$event.preventDefault(); setLanguage(lang.value)"
          >
            {{ lang.label }}
          </a>
        }

        <hr class="border-secondary opacity-50 my-2" />

        <a class="nav-link text-danger" href="#" (click)="$event.preventDefault(); logout()">
          <i class="bi bi-box-arrow-right me-2"></i>
          {{ 'header.logout' | transloco }}
        </a>
      </div>

      <!-- Desktop dropdown -->
      <div class="d-none d-lg-flex align-items-center navbar-nav">
        <button
          type="button"
          class="btn btn-sm btn-outline-primary help-guides-btn me-2"
          (click)="openHelpGuides()"
          [ngbTooltip]="'header.helpGuides' | transloco"
          tooltipClass="custom-tooltip"
          triggers="hover"
          placement="bottom"
        >
          <i class="bi bi-question"></i>
        </button>

        <div class="dropdown" ngbDropdown (openChange)="onProfileMenuOpenChange($event)">
          <button
            class="userDropdown dropdown-toggle d-flex align-items-center text-primary-brand"
            ngbDropdownToggle
            id="userDropdown"
            type="button"
          >
            @if (currentUser()?.avatar) {
              <img
                [src]="currentUser()!.avatar"
                [alt]="currentUser()!.nome"
                class="rounded-circle me-2"
                width="32"
                height="32"
              />
            } @else {
              <div
                class="rounded-circle bg-color-surface-light d-flex align-items-center justify-content-center me-2"
                style="width: 32px; height: 32px"
              >
                <span class="text-primary-custom fw-bold">
                  {{ (currentUser()?.nome?.charAt(0) || 'U').toUpperCase() }}
                </span>
              </div>
            }

            <span class="user-name" [title]="currentUser()?.nome ?? ''">{{
              currentUser()?.nome || ('header.userFallback' | transloco)
            }}</span>
          </button>

          <!--
            TG-492: itens agrupados em seções recolhíveis. "Projetos",
            "Gerenciar Usuários" e "Gerenciar Clientes" saíram daqui por
            já existirem na barra de navegação.
          -->
          <div class="dropdown-menu dropdown-menu-end bg-color-surface-lighter" ngbDropdownMenu>
            <h6 class="dropdown-header text-truncate" [title]="currentUser()?.email ?? ''">
              {{ currentUser()?.email }}
            </h6>

            <div class="dropdown-divider"></div>

            <button
              type="button"
              class="profile-group-toggle dropdown-header dropdown-toggle fs-6"
              [attr.aria-expanded]="isProfileGroupExpanded('profile')"
              (click)="toggleProfileGroup('profile')"
            >
              <i class="bi bi-person-circle me-2"></i>
              {{ 'header.profile' | transloco }}
            </button>

            <div [ngbCollapse]="!isProfileGroupExpanded('profile')">
              <a class="dropdown-item" href="#" (click)="$event.preventDefault(); openProfileModal()">
                <i class="bi bi-person me-2"></i>
                {{ 'header.profileDetails' | transloco }}
              </a>

              <a class="dropdown-item" href="#" (click)="$event.preventDefault(); openChangePasswordModal()">
                <i class="bi bi-lock me-2"></i>
                {{ 'header.changePassword' | transloco }}
              </a>

              @if (isAdminLike()) {
                <a class="dropdown-item" href="#" (click)="$event.preventDefault(); openEditEmpresa()">
                  <i class="bi bi-building me-2"></i>
                  {{ 'header.myCompany' | transloco }}
                </a>
              }
              @if (isReferralEligible()) {
                <a class="dropdown-item" routerLink="/referral">
                  <i class="bi bi-people me-2"></i>
                  {{ 'header.referral' | transloco }}
                </a>
              }
            </div>

            <div class="dropdown-divider"></div>

            <button
              type="button"
              class="profile-group-toggle dropdown-header dropdown-toggle fs-6"
              [attr.aria-expanded]="isProfileGroupExpanded('language')"
              (click)="toggleProfileGroup('language')"
            >
              <i class="bi bi-globe2 me-2"></i>
              {{ 'header.language' | transloco }}
            </button>

            <div [ngbCollapse]="!isProfileGroupExpanded('language')">
              @for (lang of languageOptions; track lang.value) {
                <a
                  class="dropdown-item language-item"
                  [class.active]="transloco.activeLang() === lang.value"
                  href="#"
                  (click)="$event.preventDefault(); setLanguage(lang.value)"
                >
                  {{ lang.label }}

                  @if (transloco.activeLang() === lang.value) {
                    <i class="bi bi-check-lg ms-2"></i>
                  }
                </a>
              }
            </div>

            @if (canViewDashboards()) {
              <div class="dropdown-divider"></div>

              <button
                type="button"
                class="profile-group-toggle dropdown-header dropdown-toggle fs-6"
                [attr.aria-expanded]="isProfileGroupExpanded('dashboards')"
                (click)="toggleProfileGroup('dashboards')"
              >
                <i class="bi bi-speedometer2 me-2"></i>
                {{ 'header.dashboards' | transloco }}
              </button>

              <div [ngbCollapse]="!isProfileGroupExpanded('dashboards')">
                @if (isAdminOrSuper()) {
                  <a class="dropdown-item" routerLink="/admin/metrics">
                    <i class="bi bi-bar-chart me-2"></i>
                    {{ 'header.metricsDashboard' | transloco }}
                  </a>
                }

                <a class="dropdown-item" routerLink="/platform-data">
                  <i class="bi bi-grid-1x2 me-2"></i>
                  {{ 'header.platformData' | transloco }}
                </a>
              </div>
            }

            @if (isSuper()) {
              <div class="dropdown-divider"></div>

              <button
                type="button"
                class="profile-group-toggle dropdown-header dropdown-toggle fs-6"
                [attr.aria-expanded]="isProfileGroupExpanded('settings')"
                (click)="toggleProfileGroup('settings')"
              >
                <i class="bi bi-gear me-2"></i>
                {{ 'header.settings' | transloco }}
              </button>

              <div [ngbCollapse]="!isProfileGroupExpanded('settings')">
                <a class="dropdown-item" routerLink="/admin/fees">
                  <i class="bi bi-percent me-2"></i>
                  {{ 'header.manageFees' | transloco }}
                </a>
              </div>
            }

            <div class="dropdown-divider"></div>

            <a class="dropdown-item text-danger" href="#" (click)="$event.preventDefault(); logout()">
              <i class="bi bi-box-arrow-right me-2"></i>
              {{ 'header.logout' | transloco }}
            </a>
          </div>
        </div>
      </div>
    } @else if (!isAuthenticated()) {
      <div class="d-flex align-items-center">
        <!-- Language select (guest only) -->
        <div class="header-language-select ms-auto me-2">
          <ng-select
            class="header-language-ng-select"
            [items]="languageOptions"
            bindLabel="label"
            bindValue="value"
            [searchable]="false"
            [clearable]="false"
            [ngModel]="transloco.activeLang()"
            [appendTo]="'body'"
            (ngModelChange)="setLanguage($event)"
          >
            <ng-template ng-label-tmp>
              <span class="header-language-trigger" aria-hidden="true">
                <i class="bi bi-globe2 me-2"></i>
                {{
                  languageOptions.find((opt) => opt.value === transloco.activeLang())?.label ||
                    ('header.languageFallback' | transloco)
                }}
              </span>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <span>{{ item.label }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    }
  </div>
</nav>
